import {
  UNIFIED_ROUTE_ABOUT,
  UNIFIED_ROUTE_EXPLORE,
  UNIFIED_ROUTE_LEARN,
} from '~/constants/routes/unified';
import { OPENED_PAGES, pathnameOf, placeUnder } from '~/utils/coach/leaveShell';

/** A place in a guest's IA bar that the back button can name. */
export type PublicBackPlace = 'learn' | 'explore' | 'about';

/** Where each of the guest bar's places lives. */
export const PUBLIC_BACK_PLACE_ROUTES: Record<PublicBackPlace, string> = {
  learn: UNIFIED_ROUTE_LEARN,
  explore: UNIFIED_ROUTE_EXPLORE,
  about: UNIFIED_ROUTE_ABOUT,
};

/** The places' own pages. */
const PLACE_PAGES: [string, PublicBackPlace][] = [
  ['learn', 'learn'],
  ['explore', 'explore'],
  ['about', 'about'],
];

/** The shell's opened pages at their public paths, less the ones whose place a guest does not have. */
const GUEST_OPENED_PAGES = OPENED_PAGES.flatMap(([segment, place]): [string, PublicBackPlace][] =>
  (place === 'learn' || place === 'explore' ? [[segment, place]] : []));

const placeOf = (pathname: string, pages: [string, PublicBackPlace][]) => placeUnder({ pathname, root: '', pages });

/** The place in the guest bar a page belongs to, where the way back goes when nothing of ours is behind it. */
export const publicHomePlace = (path: string): PublicBackPlace => {
  const pathname = pathnameOf(path);

  return placeOf(pathname, PLACE_PAGES) ?? placeOf(pathname, GUEST_OPENED_PAGES) ?? 'explore';
};

/**
 * Which of the guest bar's places going back lands on: the place whose page is behind this one, or
 * none for a page that is no place of the bar's (the landing, another job), which the button names
 * as plain back. Undefined when nothing of ours is behind this page.
 */
export const publicBackPlace = (previousEntry: string | null | undefined): PublicBackPlace | null | undefined => {
  if (typeof previousEntry !== 'string') {
    return undefined;
  }

  return placeOf(pathnameOf(previousEntry), PLACE_PAGES);
};
